<style lang="scss" scoped>
  .wallet-index-page {
    min-height: 100vh;
    background-color: #f8f8fb;
    padding-top: 52px;
    .main-container {
      width: 686px;
      // height: 478px;
      padding: 52px 0;
      margin: 0 auto 32px;
      background-color: #fff;
      box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.03);
      border-radius: 8px;
      .count-amount {
        // height: 283px;
        width: 100vh;
        margin-top: 24px;
        display: table-cell;
        vertical-align: middle;
        .balance {
          color: #000;
          text-align: center;
          font-size: 72px;
          font-weight: 600;
          line-height: 86px;
          .pre {
            color: #1D1D1D;
            font-size: 32px;
          }
          .no-zero {
            color: #FF5778;
          }
          .zero {
            color: #2A2A30;
          }
        }

        .running-count-link {
          color: #828393;
          height: 40px;
          line-height: 40px;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          .right-arrow {
            margin-left: 8px;
            margin-top: -3px;
            height: 19px;
            width: 12px;
          }
        }
      }

      .guide-show {
        width: 590px;
        margin: 64px auto 0;
        .button-link {
          font-size: 34px;
          height: 88px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #2A2A30;
          color: #FFF;
        }

        .msg {
          height: 24px;
          margin-top: 32px;
          color: rgba($color: #828393, $alpha: 0.6);
          font-size: 24px;
          text-align: center;
        }
      }
    }
    .alipay-msg {
      margin: 32px auto 0;
      padding: 0 32px;
      display: flex;
      align-items: center;
      width: 686px;
      height: 104px;
      background-color: #fff;
      box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.03);
      border-radius: 8px;
      color: #828393;
      font-size: 28px;
      .msg-l {
        flex: 1;
        text-align: left;
      }

      .msg-r {
        flex: 1;
        text-align: right;
      }
    }

    .horizontal-line {
      border-bottom: 1px solid #eeeeee;
      margin-top: 24px;
    }

    .remind-tip {
      width: 576px;
      margin: 40px auto 0;
      font-size: 24px;
      line-height: 34px;
      text-align: center;
      color: #828393;
      .manual-service {
        color: #5757FF;
        font-weight: 500;
      }
    }

  }

</style>

<template>
  <div class="wallet-index-page">
    <div class="main-container">
      <div class="count-amount">
        <p class="balance"><span :class="baseInfo.balance > 0 ? 'no-zero' : 'zero'">{{baseInfo.balance | transMoney}}</span></p>
        <div class="running-count-link" @click="$router.push({ name:'walletRunningCount' })">查看明细<img alt="IMAGE" v-lazy="'https://oss.turingsenseai.com/1611127558969653694.png'" class="right-arrow"></div>
      </div>
      <div class="guide-show">
        <!-- 用户尚未绑定支付账户 -->
        <template v-if="!baseInfo.isAlipayAccountBound">
          <p class="button-link" @click="$router.push({ name:'walletBindAlipay' })">绑定收款支付宝</p>
          <p class="msg">您需要优先绑定收款支付账户后才能提现</p>
        </template>
        <!-- 用户已经绑定支付账户 -->
        <template v-else>
          <p class="button-link" @click="$router.push({ name:'walletWithdraw' })">提现</p>
          
        </template>
      </div>
    </div>
    <div v-if="baseInfo.isAlipayAccountBound" class="alipay-msg">
      <div class="msg-l">收款支付宝</div>
      <div class="msg-r">{{baseInfo.alipayAccount}}</div>
    </div>
    <div  v-if="baseInfo.isAlipayAccountBound" class="remind-tip">
      已绑定的收款支付宝暂时无法提供系统换绑和解绑，如需要帮助可联系<span class="manual-service" @click="toAppManual">人工客服</span>
    </div>
  </div>
</template>

<script>
import { formatMoney } from '../../common/utils'
import rightArrow from '../../assets/images/wallet/arrow-right.png'
import { Indicator } from 'mint-ui'
/**
 * 用户信息对应情况
 *  mainInfo: {
        balance: 89090, // 钱包余额
        alipayAccount: '345@alipay.com',  // 支付宝账号
        singleDayWithdrawMax: 100000, // 单日提现上限
        singleDayWithdrawRest: 23000, // 单日剩余提现额度
        isAlipayAccountBound: true  // 是否已绑定支付宝账号
      }
 */
export default {
  name: 'Wallet',

  data () {
    return {
      balance: 89009, // 余额（分）
      hasBindFlag: true,
      rightArrow: rightArrow,
    }
  },

  methods: {
    getBaseInfo () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      this.$store.dispatch('GET_WALLET_MAIN_INFO', {})
    },
    toAppManual () {
      if (window.isWXWebView) {
        wx.miniProgram.navigateTo({ url: `/pages/mine/contact-guide/index` })
      } else if (window.isIOS) {
        //
      } else {
        this.$$toast('暂未实现')
      }
    }
  },

  computed: {
    baseInfo () {
      return this.$store.state.wallet.mainInfo ? this.$store.state.wallet.mainInfo.data : {}
    }
  },

  filters: {
    transMoney (num) {
      num = num || 0
      return formatMoney(num)
    }
  },

  created () {
    this.getBaseInfo()
    console.log('init-project')
  }
}
</script>
